import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Link} from 'react-router-dom'
import _ from "lodash";
import { Form, Segment, Button, Table, Label, Input, Breadcrumb } from "semantic-ui-react";
import FormErrorMessage from "../utils/FormErrorMessage";
import { 
    loadShipmentById,
    createReturnModel,
    updateReturnModelInStore,
    updateReturnModelAddressInStore,
    updateReturnLineInStore
} from "../../actions/shipment";
import {api} from '../../api';

class ReturnCreationPage extends Component {
    constructor() {
        super();
        this.state = {
            errors: [],
            loading: false,
            originalShipmentType: '',
            newShipmentType: ''
        };
    }

    componentDidMount() {
        const {params} = this.props.match;        
        if (_.isObject(params) && params.shipmentId) {
            if (parseInt(params.shipmentId) !== parseInt(this.props.shipment.id) || !this.props.shipment.id) {
                this.props.loadShipmentById(this.props.jwt, params.shipmentId).then(res => {
                    this.props.createReturnModel(res.data.data);
                    this.setPageRoutingState();
                }).catch(err => {});
            } else {
                this.props.createReturnModel(this.props.shipment);
                this.setPageRoutingState();
            }
        } else {
            this.props.history.push('/');
        }
    }

    setPageRoutingState = () => {
        const {shipment} = this.props;
        if (shipment.acct_type === 'Invoice'){
            this.setState({
                originalShipmentType: 'shipping',
                newShipmentType: 'customer-returns'
            })
        }
        if (shipment.acct_type === 'Bill') {
            this.setState({
                originalShipmentType: 'receiving',
                newShipmentType: 'vendor-returns'
            })
        }
    }

    onFormSubmit = () => {
        const errors = this.validateInput();
        if (_.isEmpty(errors)) {
            this.setState({
                errors: [],
                loading: true
            });
            api.shipment.credit(this.props.jwt, this.props.shipment.id, this.props.model).then(res => {
                const {order_id} = res.data.data;
                this.props.history.replace(`/${this.state.newShipmentType}/${order_id}/view`);
            }).catch( err => {
                console.log(err);
            });
        } else {
            this.setState({
                errors: errors,
                loading: false
            });
        }
    };

    validateInput = () => {
        const errors = [];
        const {header, lines} = this.props.model;
        if (!header.reference) {
            errors.push("Please enter a reference number");
        }
        lines.map((line, index) => {
            if (parseInt(line.qty) > line.original_qty) {
                errors.push(`To many units for line ${index + 1}`)
            }
        });
        return errors;
    };
    
    render() {
        const {model, updateReturnModelInStore, updateReturnModelAddressInStore, updateReturnLineInStore} = this.props
        const {header, lines} = model;
        return (
            <div>
                {this.props.shipment.id ? <div className="row" style={{marginBottom: '5px'}}>
                    <div className="col-md-8">
                        <Breadcrumb size="huge">
                            <Breadcrumb.Section>
                                <Link to={`/shipments/${this.state.originalShipmentType}/${this.props.shipment.id}/view`}>
                                    Shipment
                                </Link>
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                {_.isObject(this.props.shipment.relation_name) ? this.props.shipment.relation_name.company_name : ""}
                            </Breadcrumb.Section>
                            <Breadcrumb.Divider />
                            <Breadcrumb.Section>
                                Create Return
                            </Breadcrumb.Section>
                        </Breadcrumb>
                    </div>
                </div> : null}
                {this.props.shipment.id ? <div className="row">
                    <div className="col-md-12">

                        <Form size="large">
                        <Segment stacked>
                            {!_.isEmpty(this.state.errors) ? (
                                <FormErrorMessage errors={this.state.errors} />
                            ) : null}
                            <h3>Return Info</h3>
                            <Form.Group unstackable widths={3}>
                                <Form.Input 
                                    fluid 
                                    label="Return Reference #"
                                    name="reference"
                                    value={header.reference ? header.reference : ""} 
                                    onChange={(e) => {updateReturnModelInStore(e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="PO #"
                                    name="po"
                                    value={header.po ? header.po : ""} 
                                    onChange={(e) => {updateReturnModelInStore(e.target.name, e.target.value) }}
                                />
                            </Form.Group>
                            <h3>Credit To / From</h3>
                            {_.isObject(header.bill_to) ? <Form.Group unstackable widths={6}>
                                <Form.Input 
                                    fluid 
                                    label="Company"
                                    name="company"
                                    value={header.bill_to.company ? header.bill_to.company : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="First Name"
                                    name="first_name"
                                    value={header.bill_to.first_name ? header.bill_to.first_name : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Last Name"
                                    name="last_name"
                                    value={header.bill_to.last_name ? header.bill_to.last_name : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Email"
                                    name="email"
                                    value={header.bill_to.email ? header.bill_to.email : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Phone"
                                    name="phone"
                                    value={header.bill_to.phone ? header.bill_to.phone : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                            </Form.Group> : null}
                            {_.isObject(header.bill_to) ? <Form.Group unstackable widths={6}>
                                <Form.Input 
                                    fluid 
                                    label="Address 1"
                                    name="address_1"
                                    value={header.bill_to.address_1 ? header.bill_to.address_1 : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Address 2"
                                    name="address_2"
                                    value={header.bill_to.address_2 ? header.bill_to.address_2 : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="City"
                                    name="city"
                                    value={header.bill_to.city ? header.bill_to.city : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Postal"
                                    name="postcode"
                                    value={header.bill_to.postcode ? header.bill_to.postcode : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="State"
                                    name="state"
                                    value={header.bill_to.state ? header.bill_to.state : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Country"
                                    name="country"
                                    value={header.bill_to.country ? header.bill_to.country : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('bill_to',e.target.name, e.target.value) }}
                                />
                            </Form.Group> : null}

                            <h3>Return To / From</h3>
                            {_.isObject(header.ship_to) ? <Form.Group unstackable widths={6}>
                                <Form.Input 
                                    fluid 
                                    label="Company"
                                    name="company"
                                    value={header.ship_to.company ? header.ship_to.company : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="First Name"
                                    name="first_name"
                                    value={header.ship_to.first_name ? header.ship_to.first_name : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Last Name"
                                    name="last_name"
                                    value={header.ship_to.last_name ? header.ship_to.last_name : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Email"
                                    name="email"
                                    value={header.ship_to.email ? header.ship_to.email : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Phone"
                                    name="phone"
                                    value={header.ship_to.phone ? header.ship_to.phone : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                            </Form.Group> : null}
                            {_.isObject(header.ship_to) ? <Form.Group unstackable widths={6}>
                                <Form.Input 
                                    fluid 
                                    label="Address 1"
                                    name="address_1"
                                    value={header.ship_to.address_1 ? header.ship_to.address_1 : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Address 2"
                                    name="address_2"
                                    value={header.ship_to.address_2 ? header.ship_to.address_2 : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="City"
                                    name="city"
                                    value={header.ship_to.city ? header.ship_to.city : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Postal"
                                    name="postcode"
                                    value={header.ship_to.postcode ? header.ship_to.postcode : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="State"
                                    name="state"
                                    value={header.ship_to.state ? header.ship_to.state : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                                <Form.Input 
                                    fluid 
                                    label="Country"
                                    name="country"
                                    value={header.ship_to.country ? header.ship_to.country : ""} 
                                    onChange={(e) => {updateReturnModelAddressInStore('ship_to',e.target.name, e.target.value) }}
                                />
                            </Form.Group> : null}
                            
                            <h3>Item To Return</h3>



                            <div className="row" style={{marginTop: '10px', marginBottom: '10px'}}>
                                <div className="col-md-12">
                                    <Table compact>
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>SKU</Table.HeaderCell>
                                                <Table.HeaderCell>Name</Table.HeaderCell>
                                                <Table.HeaderCell>Fulfilled</Table.HeaderCell>
                                                <Table.HeaderCell>To Return</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        {_.isArray(lines) ? <Table.Body>
                                            {lines.map (line => {
                                                return (
                                                    <Table.Row key={line.uid}>
                                                        <Table.Cell>{line.inventory.sku}</Table.Cell>
                                                        <Table.Cell>
                                                        {line.inventory.name} &nbsp;&nbsp;
                                                        {line.inventory.type !== 'Inventory' ? <Label size='tiny' color='purple'>{line.inventory.type}</Label> : null}
                                                        </Table.Cell>
                                                        <Table.Cell>{line.original_qty}</Table.Cell>
                                                        <Table.Cell>
                                                            <Input value={line.qty} size='mini' type="number"
                                                                onChange={(e, {value}) => updateReturnLineInStore(line, value) }/>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                );
                                            })}
                                        </Table.Body>: null}
                                    </Table>                                        
                                </div>
                            </div>
                            <Button
                                color="teal"
                                onClick={this.onFormSubmit}
                                size="mini"
                                loading={this.state.loading}
                            >
                                Save
                            </Button>
                        </Segment>
                    </Form>
                    </div>
                </div> : null}

            </div>
        );
    }
}

ReturnCreationPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
        replace: PropTypes.func.isRequired
    }).isRequired,
    createReturnModel: PropTypes.func.isRequired,
    model: PropTypes.object.isRequired,
    jwt: PropTypes.string.isRequired,
    shipment: PropTypes.object.isRequired,
    loadShipmentById: PropTypes.func.isRequired,
    updateReturnModelInStore: PropTypes.func.isRequired,
    updateReturnModelAddressInStore: PropTypes.func.isRequired,
    updateReturnLineInStore: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        shipment: state.shipment.shipment,
        model: state.returnStore.model,
        jwt: state.auth.jwt
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            loadShipmentById,
            createReturnModel,
            updateReturnModelInStore,
            updateReturnModelAddressInStore,
            updateReturnLineInStore
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReturnCreationPage);



// WEBPACK FOOTER //
// ./src/components/shipments/ReturnCreation.js